import { useNavigate } from 'react-router-dom';
import Button, { ButtonVariant } from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import InputSearch from 'src/components/organisms/InputSearch';
import { FiltersContainer, StyledDiv } from './styles';

interface IOwnerListFiltersProps {
  onSearch: (query: string) => void;
  searchQuery: string;
  allowCreateOwners: () => boolean;
}

const OwnerListFilters = ({ onSearch, searchQuery, allowCreateOwners }: IOwnerListFiltersProps) => {
  const navigate = useNavigate();
  return (
    <FiltersContainer>
      <InputSearch
        onSearch={({ value }) => onSearch(value)}
        onClear={() => onSearch('')}
        name="OwnerListSearch"
        value={(searchQuery && decodeURIComponent(searchQuery)) || ''}
        placeholder="Search"
      />
      {allowCreateOwners() && (
        <StyledDiv>
          <Button
            name="add_owner_button"
            variant={ButtonVariant.contained}
            onClick={() => navigate(`/owners/create`)}
          >
            Add owner&nbsp;&nbsp;
            <Icon icon="plus" />
          </Button>
        </StyledDiv>
      )}
    </FiltersContainer>
  );
};

export default OwnerListFilters;
